import { useCommon } from '@/core/useCommon'
import { toast } from '@/ui/useToastStore'
import { logout, setUserState } from '@/store/user/useUserStore'
import SecondPageHeader from '@/views/common/SecondPageHeader'
import StrongPasswordForm from '@/views/UpdatePassword/components/StrongPasswordForm'

// 強制修改密碼頁: 登入後密碼強度不足，修改完成後才可繼續操作
const ForceUpdatePassword = () => {
  const { t } = useCommon()

  // 修改成功，進入後台
  const onSuccess = () => {
    toast({ message: t('old:pwdUpdateSuccess'), type: 'success' })
    setUserState({ needUpdatePwd: false })
  }

  return (
    <div className="h-full w-full overflow-y-auto bg-[#EDEEF0]">
      {/* 返回: 登出回到登入頁 */}
      <SecondPageHeader title={t('old:pwdUpdateStep')} onBack={logout} />

      <div className="sm:max-w-container bg-white sm:mx-auto">
        <div className="sm:mx-auto sm:max-w-550 sm:py-20">
          {/* 標題 */}
          <div className="flex flex-col gap-4 p-12 sm:gap-8">
            <div className="text-16 sm:text-20 leading-19 font-medium text-[#0D2245] capitalize sm:leading-24">{t('old:pwdUpdateForSecurity')}</div>
            <div className="text-12 sm:text-14 leading-14 text-[#6D7693] capitalize sm:leading-20">{t('old:pwdNotMeetStandard')}</div>
          </div>

          <StrongPasswordForm onSuccess={onSuccess} className="p-12" />
        </div>
      </div>
    </div>
  )
}

export default ForceUpdatePassword
